import { showOnBoardingDelete } from '@cian/favorites-assign-widget';

import { deleteFromFavoriteRequest as _deleteFromFavorite } from '.';
import { TThunkAction } from '../../../types/redux';
import {
  EDealType,
  EEntityType,
} from 'shared/repositories/favorites/entities/delete_user_favorites/DeleteOfferFromFavoritesRequest';
import { updateFavorite } from 'shared/types/actions/favorites';

interface IDeleteFromFavoriteProps {
  offerId: number;
  dealType: EDealType;
  entityType: EEntityType;
  currentCount: number;
}

export const deleteFromFavorite =
  ({ offerId, dealType, entityType, currentCount }: IDeleteFromFavoriteProps): TThunkAction<Promise<void>> =>
  async (dispatch, _getState, context) => {
    try {
      await _deleteFromFavorite(context, { offerId, dealType, entityType });
      dispatch(updateFavorite({ offerId, isFavorite: false }));

      dispatch(showOnBoardingDelete());
      // oxlint-disable-next-line typescript/no-explicit-any
      (window as any).__header_favorites_count__ = currentCount - 1;

      return window.__header_updateFavorites__ && window.__header_updateFavorites__(true);
    } catch (error) {
      context.logger.error(error, {
        offerId,
        domain: 'deleteFromFavorite',
      });
    }
  };
